export const initAvailProSearchGoal = () => {
  if (!document.getElementById('results-metric')) {
    console.log('results-metric not found');
    return;
  }

  const searchGuid = document.getElementById('results-metric').dataset.guid;
  const hasSearchBeenLogged = getCookie('search-guid') === searchGuid;

  if (hasSearchBeenLogged) {
    return;
  }

  document.cookie = `search-guid=${searchGuid}`;

  if (document.getElementById('availability-results__react-anchor').dataset.initialdata.includes('"provider":"availpro"')) {
    ga('send', 'event', 'Third party booking results');
    return;
  }
};

const getCookie = (cname) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i <ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
